<div class="edit-profile-dialog-content no-close-btn-header d-flex flex-row"
  [ngClass]="{'edit-resume-popup': ctrl === 'PROFILE_ADD_CER'}">
  <div class="popup-column-group profile-photo-video-column">
    <div class="column-title">Unique Talents</div>
    <div class="photo-video-ui">
      <div class="photo-video-container">
        <div class="profile-video-ui-wrapper">
          <video (loadeddata)="positionVideo()" id="vidPreview" [hidden]="!videoSelected"
          [src]="selectedVideoUrl" autoplay loop muted playsinline></video>
        </div>
        <img id="imgPreview" [hidden]="videoSelected" class="imgPreview" height="100%" src="{{selectedPhoto}}">
        <img [hidden]="photoSelected || videoSelected" class="noProfilePhoto_img" width="100%" height="100%"
          src="../../../../assets/images/default-profile-picture-new.svg">
          <div class="ui-popover openToggler">
            <button id="muteBtn" [hidden]="!videoSelected" (click)="muted(!muteClassAdd)"
              class="item-video-sound-control" [ngClass]="{'mute' : muteClassAdd}">
            <img class="audio-control-icon-img mute-icon"
              src="../../../../assets/images/sound-muted-icon.png"
              srcset="../../../../assets/images/sound-muted-icon@2x.png 2x, ../../../../assets/images/sound-muted-icon@3x.png 3x">
              <img class="audio-control-icon-img sound-icon"
                src="../../../../assets/images/sound-unmuted-icon.png"
                srcset="../../../../assets/images/sound-unmuted-icon@2x.png 2x, ../../../../assets/images/sound-unmuted-icon@3x.png 3x">
              </button>
            </div>
          </div>
          <div ngbDropdown class="camera-menu dropdown">
            <button ngbDropdownToggle class="btn dropdown-toggle" type="button" id="cameraMenuDropdown">
              <img src="../../../../assets/images/profile-camera-icon.png"
                srcset="../../../../assets/images/profile-camera-icon@2x.png 2x, ../../../../assets/images/profile-camera-icon@3x.png 3x"
                class="profile-camera-icon">
            </button>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="cameraMenuDropdown">
              <a ngbDropdownItem (click)="recordVideo()" (keydown.enter)="recordVideo()" class="dropdown-item">Take a Video</a>
			  <a ngbDropdownItem (click)="removeVideo()" (keydown.enter)="removeVideo()" class="dropdown-item">Delete Video</a>
            </div>
          </div>
        </div>
        <div class="photo-video-hint">
          Record a short video highlighting your unique strengths, awards, certifications, recognitions, volunteer work, or other relevant achievements.
        </div>
      </div>
      <div class="popup-column-group form-container-column edit-profile-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-title">Talent &amp; Certification</h4>
        </div>
        <div class="modal-body">
          <div class="required-legend"><span class="requiredAsterix">*</span> Required Information</div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Talent<span class="requiredAsterix">*</span></label>
            <input inputRestriction="allChars" [(ngModel)]="certificationName"
              [ngClass]="{'error': showCertificationNameError}" maxlength="100"
			  (ngModelChange)="validateCertificationName(); onChange($event)" (blur)="certificationName = certificationName.trim(); validateCertificationName()" type="" name=""
              class="form-control unnanu-text-input-style-1" id="" value="" placeholder="Enter talent" required />
            <label class="error" [hidden]="!showCertificationNameError">{{ certificationNameErrorMessage
            }}</label>
          </div>
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Reference<span class="requiredAsterix">*</span></label>
            <input inputRestriction="noSpecialChars" [ngClass]="{'error': showCompanyError}" (blur)="hideCompanySuggestions()"
              maxlength="100" [(ngModel)]="company" type="" name="company"
              class="form-control unnanu-text-input-style-1" id="" value=""
              placeholder="Search or add reference" [ngbTypeahead]="search"
              (selectItem)="companySelectedFn($event)" [resultTemplate]="rt" required (ngModelChange)="onChange($event)"/>
            <ng-template #rt let-r="result" let-t="term">
              <img [src]="(r.LogoUrl | logoUrl) || '../../../../../../assets/images/education-default.jpg'"
                (error)="$any($event.target).src='../../../../../../assets/images/education-default.jpg'"
                class="me-2" style="width:16px;height:16px;object-fit:contain;vertical-align:middle;">
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label class="error" [hidden]="!showCompanyError">Please enter the issuing organization.</label>
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Talent Type<span class="requiredAsterix">*</span></label>
            <input inputRestriction="allChars" [(ngModel)]="licenceNumber" [ngClass]="{'error': showLicenceNumberError}"
              maxlength="80" (change)="validateLicenceNumber()" (blur)="licenceNumber = licenceNumber.trim(); validateLicenceNumber()" type="" name=""
              class="form-control unnanu-text-input-style-1" id="" value="" placeholder="Enter talent type"
              required (ngModelChange)="onChange($event)" />
            <label class="error" [hidden]="!showLicenceNumberError">{{ LicenceNumberErrorMessage }}</label>
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Description</label>
            <textarea [(ngModel)]="notes" rows="1" class="form-control unnanu-text-input-style-1"
            [ngClass]="{error: remaining() < 0}" maxlength="{{ maxLength }}" (ngModelChange)="onChange($event)"></textarea>
            @if (remaining() < 0) {
              <span>{{ remaining() }}</span>
            }
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Dates<span class="requiredAsterix">*</span></label>
            <div class="has-no-end-time">
              <span class="unnanu-check-box-style-1">
                <input id="ItemDoesNotExpire" [(ngModel)]="isCurrentlyWorking" type="checkbox" name=""
                  class="form-check" (click)="currentlyWorking()" (ngModelChange)="onChange($event)" />
                <label for="ItemDoesNotExpire"></label>
              </span>
              <label class="has-no-end-time-label" for="ItemDoesNotExpire">Does Not Expire</label>
            </div>
            <div class="time-duration-wrapper d-flex">
              <div class="duration-time">
                <div class="month-year-group">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="Start year"
                      [options]="yearOptions" [value]="startYear"
                      (valueChange)="startYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (startDateError) {
                    <label class="error">{{startDateErrorMessage}}</label>
                  }
                  @if (timePeriodError) {
                    <label class="error">{{timePeriodErrorMessage}}</label>
                  }
                </div>
              </div>
              <div class="duration-to-label">-</div>
              <!-- Begin of the to time select dropdown -->
              <!-- This must hide when clicked on the checkbox -->
              <div class="duration-time duration-end-time" [hidden]="isCurrentlyWorking">
                <div class="month-year-group">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="End year"
                      [options]="endYearOptions" [value]="endYear"
                      (valueChange)="endYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (endDateError) {
                    <label class="error">{{endDateErrorMessage}}</label>
                  }
                </div>
              </div>
              <!-- End of the to time select dropdown -->
              <div [hidden]="!isCurrentlyWorking" class="duration-time duration-end-time">
                <div class="no-end-date-label">Present</div>
              </div>
            </div>
            <br>
            </div>
          </div>
          <div class="modal-footer text-end">
            <div class="footer-buttons-row d-flex justify-content-between align-items-center">
              @if (data.COGUID) {
                <button type="button" class="delete-card-button large float-left" (click)="deleteData()"
                  >
                  Delete
                </button>
              }
			  @else {
				<button type="button" class="delete-card-button large float-left"
                  >

                </button>
			  }
			  <div>
              <button type="button" class="cancel-changes-button large " (click)="close()">
                Cancel
              </button>
              <button type="button" class="save-changes-button large ms-2"
                [disabled]="!valueUpdated || !certificationName.trim() || !company.trim() || !licenceNumber.trim() || startYear === 'Year:' || (!isCurrentlyWorking && endYear === 'Year:') || hasToShowCompanySuggestions || startDateError || endDateError || timePeriodError || showCertificationNameError || showLicenceNumberError"
                (click)="saveData()">
                Save Changes
              </button>
			</div>
            </div>
          </div>
        </div>
      </div>
